import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=60abe634&scoped=true&"
import script from "./ProductVariants.vue?vue&type=script&lang=ts&"
export * from "./ProductVariants.vue?vue&type=script&lang=ts&"
import style0 from "./ProductVariants.vue?vue&type=style&index=0&id=60abe634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abe634",
  null
  
)

export default component.exports